import { useDisclosure } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { MdOutlineDeleteForever } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { DeleteOnboardingExpertModal } from "../Modals/DeleteOnboardingExpertModal";
import OnboardingExpertDataService from "../../services/OnboardingExpert";
import ExpertDataService from "../../services/Expert";
import { expert, transformOnboardingExpertDetails } from "../../Config/Expert";

export const SingleOnboardingRow = ({ data, id, func }: any) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const token = localStorage.getItem("logged_in_user_token");

  function calculateSubmissionPercentage(data: any) {
    let totalQuestions = data.length;
    let submittedQuestions = 0;

    for (let i = 0; i < data.length; i++) {
      let answerData = data[i].answer_data;
      let type = data[i].question_type;

      if (["document", "text"].includes(type) && answerData[0].label !== "") {
        submittedQuestions++;
      } else if (
        ["checkbox", "radiobutton"].includes(type) &&
        !answerData.every((q: any) => q.value === false)
      ) {
        submittedQuestions++;
      }
    }

    let submissionPercentage = (submittedQuestions / totalQuestions) * 100;
    return submissionPercentage.toFixed(0);
  }

  const { email, is_approved, is_submitted, questions } = data;
  const navigate = useNavigate();
  const [modal, setModal] = useState("");
  const [approvedStatus, setApprovedStatus] = useState(is_approved);
  const [createdStatus, setCreatedStatus] = useState(false);
  const [expertData, setExpertData] = useState<any>(expert);

  const approveExpert = () => {
    OnboardingExpertDataService.updateOnboardingExpert(email, {
      is_approved: approvedStatus,
    });
  };

  const checkIfOnboardingExpertExist = async (email: string) => {
    const res = await ExpertDataService.getExperts(token);
    setCreatedStatus(
      res.data.some((expert: any) => expert.data.personal_email_id === email)
    );
  };

  const createExpert = async (email: string) => {
    const res = await OnboardingExpertDataService.getSingleOnboardingExpert(
      email
    );
    // console.log(res.data.questions[0]);
    const transformedExpertData: any = transformOnboardingExpertDetails(email,
      res.data.questions
    );
    // console.log("Transformed expert:", transformedExpertData);
    setExpertData(transformedExpertData);
    ExpertDataService.create(transformedExpertData)
      .then((response: any) => {
        // console.log(response);
        navigate("/experts");
      })
      .catch((e: Error) => {
        console.log(e);
      });
    setCreatedStatus(true);
  };

  useEffect(() => {
    approveExpert();
  }, [approvedStatus]);

  useEffect(() => {
    checkIfOnboardingExpertExist(data.email);
  }, []);

  return (
    <tr>
      <td>{email}</td>
      <td>{calculateSubmissionPercentage(questions)}% form filled</td>
      <td>{is_submitted ? "Submitted" : "Not Submitted"}</td>
      <td>
        <div className="d-flex align-items-center">
          <button
            type="button"
            className={approvedStatus ? "disabledButton" : "btn"}
            onClick={() => {
              if (!is_approved) {
                setApprovedStatus(true);
              }
            }}
            disabled={approvedStatus}
            style={
              approvedStatus
                ? { color: "#327171", fontWeight: "bolder" }
                : { backgroundColor: "#327171", color: "white" }
            }
          >
            {approvedStatus ? "Approved" : "Approve"}
          </button>
        </div>
      </td>
      <td>
        <div className="d-flex align-items-center">
          <button
            type="button"
            className={createdStatus ? "disabledButton" : "btn"}
            onClick={() => {
              createExpert(data.email);
            }}
            disabled={createdStatus}
            style={
              createdStatus
                ? { color: "#327171", fontWeight: "bolder" }
                : { backgroundColor: "#327171", color: "white" }
            }
          >
            {createdStatus ? "Created" : "Create"}
          </button>
        </div>
      </td>
      <td>
        <div className="d-flex align-items-center">
          <button
            type="button"
            className="btn disabledButton"
            onClick={() => navigate(`/onboarding-experts/view/${email}`)}
          >
            <FaEye style={{ color: "#f48a0f" }} />
          </button>
        </div>
      </td>
      <td>
        <div className="d-flex align-items-center">
          <span title="Delete">
            <MdOutlineDeleteForever
              className="deleteButton pointer"
              onClick={() => {
                setModal("deletemodal");
                onOpen();
              }}
            />
          </span>
        </div>
      </td>

      {modal === "deletemodal" && (
        <DeleteOnboardingExpertModal
          isOpen={isOpen}
          onClose={onClose}
          func={func}
          id={email}
        />
      )}
    </tr>
  );
};
